export default "__VITE_ASSET__855e39b1__"